/**
 * Support ticket enums — must match the backend SupportTicketCategory and
 * SupportTicketStatus enums (EasyPlanner.Common.Enums).
 */

export const SupportTicketCategory = {
  BUG: 0,
  FEATURE_REQUEST: 1,
  OTHER: 2,
};

export const SupportTicketStatus = {
  OPEN: 0,
  IN_PROGRESS: 1,
  RESOLVED: 2,
  CLOSED: 3,
};

/** i18n keys for each category, keyed by enum value. */
export const SupportTicketCategoryLabelKeys = {
  [SupportTicketCategory.BUG]: "Dashboard.Support.category.bug",
  [SupportTicketCategory.FEATURE_REQUEST]:
    "Dashboard.Support.category.featureRequest",
  [SupportTicketCategory.OTHER]: "Dashboard.Support.category.other",
};

/** i18n keys for each status, keyed by enum value. */
export const SupportTicketStatusLabelKeys = {
  [SupportTicketStatus.OPEN]: "Dashboard.Support.status.open",
  [SupportTicketStatus.IN_PROGRESS]: "Dashboard.Support.status.inProgress",
  [SupportTicketStatus.RESOLVED]: "Dashboard.Support.status.resolved",
  [SupportTicketStatus.CLOSED]: "Dashboard.Support.status.closed",
};

/** Tailwind badge tint per status. */
export const SupportTicketStatusBadgeClass = {
  [SupportTicketStatus.OPEN]: "bg-blue-100 text-blue-700",
  [SupportTicketStatus.IN_PROGRESS]: "bg-amber-100 text-amber-700",
  [SupportTicketStatus.RESOLVED]: "bg-brand-100 text-brand-700",
  [SupportTicketStatus.CLOSED]: "bg-ink-200 text-ink-600",
};

/**
 * The snackbar's message after a booking's status changes, keyed by the status
 * string the API takes. Bookings and Calendar both offer these three actions.
 */
export const BookingStatusNoticeKeys = {
  Confirmed: "Dashboard.Bookings.notices.confirmed",
  Cancelled: "Dashboard.Bookings.notices.cancelled",
  Completed: "Dashboard.Bookings.notices.completed",
};

/** The 5MB image cap enforced by the backend, mirrored for a friendly client check. */
export const SUPPORT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

/**
 * What kind of entity a business is, for invoicing. Must match the backend
 * BuyerType enum (EasyPlanner.Common.Enums).
 *
 * The distinction is only "does this buyer have a fiscal code" — a PFA and an
 * SRL are both COMPANY, because both hold a CUI and both get the same kind of
 * invoice. INDIVIDUAL is a private person, invoiced B2C.
 *
 * It is asked rather than inferred: "has no fiscal code" and "mistyped the
 * fiscal code" look identical in the data and mean opposite things, and falling
 * back to a consumer invoice would hand a company a document it cannot deduct
 * VAT against.
 */
export const BuyerType = {
  COMPANY: 0,
  INDIVIDUAL: 1,
};
